
export const environment = {
  // --------------------Local Server Api URL--------------------

  // baseUrl: 'http://192.168.0.142:8001/',


  // baseUrl: 'http://127.0.0.1:8000/',

  // ----------------------------------------------------
  // --------------------Test Server Api Url--------------------

  baseUrl: 'https://sumit.techiebears.com/',

  // --------------------Live Server Api Url--------------------

  // baseUrl: 'http://35.154.140.25/',
  // // ----------------------------------------------------
}

// === AWS Configuration ===
import AWS from 'aws-sdk'
window.Buffer = window.Buffer || require("buffer").Buffer;

//-------------- Test ----------------------------------------------

export const S3_BUCKET = 'sumeet-investors-images';
export const REGION = 'ap-south-1';


export const awsConfigration = AWS.config.update({
  accessKeyId: 'AKIA4274YTZLO63FQ7VS',
  secretAccessKey: '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'
})

//------------------------------ Live ----------------------------

// export const S3_BUCKET = 'sumeet-images';
// export const REGION = 'ap-south-1';


// export const awsConfigration = AWS.config.update({
//   accessKeyId: 'AKIAQGOK5M27ZSJ37TMC',
//   secretAccessKey: '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'
// })

// // === Bucket configuration ===

export const myBucket = new AWS.S3({
  params: { Bucket: S3_BUCKET },
  region: REGION,
})

// ==Building Link== 

// Test
export const BuildingLink = "https://sumeet-investors-images.s3.ap-south-1.amazonaws.com/"

//Live
// export const BuildingLink = "https://sumeet-images.s3.ap-south-1.amazonaws.com/"